const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

export function formatPrice(value: number | string): string {
    if (typeof value === 'string' && value.trim() === '') {
        return value;
    }

    const numericValue = Number(value);

    return Number.isFinite(numericValue) ? currencyFormatter.format(numericValue) : String(value);
}
